module.exports = __webpack_public_path__ + "img/hos3.f5a72e8b.png";